import axiosServices from './request';

const UserCenter = axiosServices('usercenter');

export default {
  /**获取手机区号 */
  getPhoneArea: UserCenter('get', 'common/getPhoneAreaMap'),

  /**获取手机区号 */
  adviserLogin: UserCenter('post', 'user/login')
};
